import { Chip, useMediaQuery, useTheme } from "@mui/material";

interface IProps {
    clauseChecklist?: string;
}

export const ClauseChecklistChip = ({ clauseChecklist }: IProps) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    if (!clauseChecklist) {
        return null;
    }

    return (
        <Chip
            label={clauseChecklist}
            color="primary"
            variant="outlined"
            size={isMobile ? "small" : "medium"}
        />
    );
};
